import React, { useState } from "react";
import gridData from "../../../../gameDataArrays";
import tickIcon from "../../../../icons/tickIcon.png";
import "./SelectCategory.css";

const SelectCategory = ({ showSelection, beginRound }) => {
  const [selectSize, setSize] = useState(0);
  const [selectHeight, setHeight] = useState("30px");

  const selectCategory = gridData.gameData.map((catagoryName, index) => (
    <option value={index} key={index}>
      {catagoryName.category}
    </option>
  ));

  let selectSizeVar = 14;

  // Handles select menu usage via keyboard inputs
  const handleEnterKey = (event) => {
    if (event.keyCode === 13) {
      setSize(selectSizeVar);
    }
  };

  return (
    <div className="selectionContainer">
      <div className="selectionBar">
        <label className="selectionLabel">Choose a category:</label>

        <select
          className="selectionBox"
          name="category"
          id="category"
          size={selectSize}
          style={{ height: selectHeight }}
          onMouseDown={() => {
            setSize(selectSizeVar);
            setHeight("auto");
          }}
          onKeyDown={(event) => handleEnterKey(event)}
          onChange={() => {
            setSize(0);
            setHeight("30px");
          }}
          onBlur={() => {
            setSize(0);
            setHeight("30px");
          }}
          onInput={(event) => {
            showSelection(event.target.value);
          }}
        >
          <option value={"none"}>- Select Category -</option>
          {selectCategory}
        </select>
      </div>

      <div
        className="confirmSelectionButton"
        onClick={() => {
          beginRound();
        }}
      >
        <div className="confirmSelectionButtonContents">
          Begin
          <img
            className="tickIcon"
            src={tickIcon}
            alt="confirm the category selection"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectCategory;
